export default {
  GET_CURRENT_USER: (state) => {
    return state.currentUser;
  },
};
